module.exports = __webpack_public_path__ + "static/img/service13.49ac09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/service13.png
// module id = a0K7
// module chunks = 1 2